module.exports = __webpack_public_path__ + "img/parcel.24fbae9.webp";